import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CompanyService } from 'app/company/services/company.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserService } from 'app/core/services/user.service';
import { User } from 'app/shared/models/User';
import { Result } from 'app/core/models/result';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserType } from '../../../account/models/user-type.model';

@Component({
    selector: 'app-company-users-add',
    templateUrl: './company-users-add.component.html',
    styleUrls: ['./company-users-add.component.css']
})
export class CompanyUsersAddComponent implements OnInit {
    errors: string[];
    selectedMembershipId: string;
    userAddForm: FormGroup;
    submitAttempt = false;
    users: User[];
    userTypes: UserType[];
    @Input() companyId: string;
    @Output() companyUserAdded: EventEmitter<string> = new EventEmitter<string>();

    constructor(
        private companyService: CompanyService,
        private fb: FormBuilder,
        private userService: UserService,
        private modalService: NgbModal
    ) { }

    ngOnInit() {
        this.userService.getUsers().subscribe(
            users => this.users = users,
            error => {
                console.log(error);
            }
        );

        this.userService.getUserTypes().subscribe(
            userTypes => this.userTypes = userTypes,
            error => {
                console.log(error);
            }
        );

        this.userAddForm = this.fb.group({
            siteUserId: ['', Validators.required],
            companyId: [this.companyId],
            userTypeId: ['', Validators.required]
        });
    }

    addUserToCompany(): void {
        this.submitAttempt = true;
        if (this.userAddForm.valid) {
            const formValue = this.userAddForm.value;
            formValue.companyId = this.companyId;
            this.companyService.addUser(formValue).subscribe(
                result => {
                    this.companyUserAdded.emit(result);
                    this.userAddForm.reset();
                    this.submitAttempt = false;
                    this.modalService.dismissAll('saved');
                },
                error => {
                    this.errors = (<Result>error).errorList;
                    this.submitAttempt = false;
                }
            );
        }
    }

    openAddCompany(content) {
        this.modalService.open(content);
    }
}
